import classNames from 'classnames';
import React from 'react';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';

type Props = {
  onClick: () => void;
  text: string;
  imageUrl?: string;
  isPrev?: boolean;
};

const AssetGroup = ({ onClick, text, imageUrl, isPrev = false }: Props) => {
  return (
    <div
      className={classNames(
        'tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-gap-3 tw-rounded-button tw-border-2 tw-border-neutrals-light-grey hover:tw-border-neutrals-medium-grey tw-py-2 tw-px-4 tw-text-body tw-transition tw-duration-300 tw-bg-white',
        {
          'tw-justify-start': isPrev,
          'tw-justify-between': !isPrev,
        }
      )}
      onClick={onClick}>
      {isPrev && <BsChevronLeft size={16} className='tw-text-body' />}

      <div className='tw-inline-flex tw-items-center tw-gap-3'>
        <div className='tw-inline-flex tw-h-[45px] tw-w-[55px] tw-items-center tw-justify-center'>
          {imageUrl && <img src={imageUrl} alt={text} className='tw-max-h-full tw-max-w-full' />}
        </div>
        <p className='tw-mb-0 tw-text-sm tw-font-bold tw-uppercase tw-text-body'>{text}</p>
      </div>

      {!isPrev && <BsChevronRight size={16} className='tw-text-body' />}
    </div>
  );
};

export default AssetGroup;
